import { CandidateOfferSalaryModel } from "../offers/candidate-offer-salary.model";

export const IHomeOffer = Object.freeze({
  qualification: "qualification",
  postalCode: "postal_code",
  salary: "salary",
  url: "url",
  picture: "picture",
  contract: "contract",
});

export class HomeOfferModel {
  constructor(data = {}) {
    this[IHomeOffer.qualification] = data[IHomeOffer.qualification];
    this[IHomeOffer.postalCode] = data[IHomeOffer.postalCode];
    this[IHomeOffer.salary] = data[IHomeOffer.salary];
    this[IHomeOffer.url] = data[IHomeOffer.url];
    this[IHomeOffer.picture] = data[IHomeOffer.picture];
    this[IHomeOffer.contract] = data[IHomeOffer.contract];
  }

  getQualification() {
    return this[IHomeOffer.qualification];
  }

  getPostalCode() {
    return this[IHomeOffer.postalCode];
  }

  getSalary() {
    return new CandidateOfferSalaryModel(this[IHomeOffer.salary]);
  }

  getUrl() {
    return this[IHomeOffer.url];
  }
  getPicture() {
    return this[IHomeOffer.picture];
  }
  getContract() {
    return this[IHomeOffer.contract];
  }
}
